import { Node } from "@tiptap/core";
import { mergeAttributes } from "@tiptap/react";

export const PageContent = Node.create({
    name: "pageContent",
    group: "block",
    content: "block+",

    parseHTML() {
        return [
            {
                tag: 'div[data-type="page-content"]',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, {
                "data-type": "page-content",
                class: "page-content",
            }),
            0,
        ];
    },
});
